/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const skuBuilderWithDash = (sku) => {
    let lastDashIndex = 0;
    const endIndex = sku.length;
    for (let i = 0; i < sku.length; i += 1) {
        if (sku[i] === '-') {
            lastDashIndex = i + 1;
        }
    }

    return sku.slice(lastDashIndex, endIndex);
};

const skuBuilderWithUnderscore = (sku) => {
    const firstUnderscoreIndex = sku.indexOf('_');
    return sku.slice(firstUnderscoreIndex + 1, sku.length);
};

const skuProductBuilder = (sku) => {
    if (sku.indexOf('-') !== -1) {
        return skuBuilderWithDash(sku);
    }
    return skuBuilderWithUnderscore(sku);
};

export {
    skuProductBuilder,
    skuBuilderWithUnderscore,
};
